import NotificationActions from '../../../actions/NotificationActions';
import GuestActions from '../../../actions/GuestActions';
import GuestApi from '../../../api/GuestApi';

import UserStore from '../../../stores/UserStore';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';

import PrimaryIdentification from './PrimaryIdentification.react';
import SecondaryIdentification from './SecondaryIdentification.react';
import AddSecondaryIdentification from './AddSecondaryIdentification.react';
import AjaxPromises from '../../../utils/AjaxPromises';
class ViewIdentification extends React.Component {

    constructor(props) {
        super(props);

        var id = this.props.guest.identifications;

        var mjStateId = false;
        var driversLicense = false;

        for (var i=0; i<id.length; i++) {
            switch (id[i].type)
            {
                case 'MJStateIDNo':
                    mjStateId = id[i];
                    break;

                case 'DriversLicenseId':
                    driversLicense = id[i];
                    break;
            }
        }

        this.state = {
            confirmClear : false,

            mjStateIdNo        : mjStateId ? mjStateId.number : false,
            mjStateIdExp       : mjStateId ? moment(mjStateId.ExpirationDate).format('YYYY-MM-DD') : '0000-00-00',
            mjStateIdImg       : mjStateId ? mjStateId.image_url : false,
            mjStateIdLoad      : false,

            driversLicenseNo   : driversLicense ? driversLicense.number : false,
            driversLicenseExp  : driversLicense ? moment(driversLicense.ExpirationDate).format('YYYY-MM-DD') : '0000-00-00',
            driversLicenseImg  : driversLicense ? driversLicense.image_url : false,
            driversLicenseLoad : false,

            AdditionalId: [],
            fetchedAddionalId: false
        };

        this.onChange = this.onChange.bind(this);
        this.onMjStateIdChange = this.onMjStateIdChange.bind(this);
        this.saveMjStateId = this.saveMjStateId.bind(this);
        this.removeMjStateId = this.removeMjStateId.bind(this);
    }

    componentDidUpdate() {
        if (this.props.page == 'identification' && !this.state.fetchedAddionalId) {
            var formData = UserStore.getApiData();
            formData.guest_id   = this.props.guest.Guest_id;
            GuestApi.loadSecondaryId(formData).then(res => {
                this.setState({ AdditionalId: res.Data, fetchedAddionalId: true })
            })
        }
    }

    onChange(field, val) {
        this.setState({ [field] : val });
    }

    onMjStateIdChange(e) {
        var self = this;

        var reader = new FileReader();
        reader.readAsDataURL( e.target.files[0] );

        reader.onload = function(upload) {
            self.setState({ mjStateIdImg : self.dataURItoBlob(upload.target.result) }, () => {
                self.saveMjStateId();
            });
        }.bind(this);
    }

    saveMjStateId() {
        var self = this;

        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;
        formData.MJStateIDNo    = this.state.mjStateIdNo;
        formData.ExpirationDate = this.state.mjStateIdExp+'T00:00:00';
        formData.ImgItem        = this.state.mjStateIdImg;

        this.setState({ mjStateIdLoad : true }, () => {
            AjaxPromises.POST(EndPoints.UPDATE_PRIMARY_ID,
                formData).then(res => {
                    if (res.Result === 'false') {
                        NotificationActions.addNotification({type:'error',body:'Image not updated'})
                    } else {
                        NotificationActions.addNotification({type:'success',body:'Image updated'})

                        GuestActions.loadFullGuest(self.props.guest.Guest_id);
                    }
                }
            );
        });
    }

    removeMjStateId() {
        var self = this;

        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;

        this.setState({ mjStateIdLoad : true }, () => {
            AjaxPromises.POST(EndPoints.DELETE_PRIMARY_ID,
                formData).then(res => {

                    if (res.Result === 'false') {
                        NotificationActions.addNotification({type:'error',body:'Image not removed'})
                    } else {
                        self.setState({ confirmClear : false, mjStateIdImg : false }, () => {
                            NotificationActions.addNotification({type:'success',body:'Image removed successfully'})

                            GuestActions.loadFullGuest(self.props.guest.Guest_id);
                        })
                    }
                }
            );
        });
    }

    dataURItoBlob(dataURI) {
        var byteString = false;

        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = dataURI.split(',')[1];
        }

        return byteString;
    }

    render() {
        var guest = this.props.guest;
        var page  = this.props.page;
        var { AdditionalId } = this.state;

        if (page !== 'identification')
            return null;

        return (
            <div className='container'>

                <div className='row'>
                    <div className='col-12'>
                        <div className='profile-main__container--header profile-main__container--first'>
                            MMJ ID
                        </div>
                    </div>
                </div>

                <PrimaryIdentification
                    guest={guest} />

                {!this.state.fetchedAddionalId &&
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '2rem'}}>
                        <i className='fa fa-spinner fa-pulse' /> 
                    </div>
                }

                { AdditionalId.length > 0 &&
                    <div
                        className='row'
                        style={{'paddingTop' : '30px'}}>

                        <div className='col-12'>
                            <div className='profile-main__container--header profile-main__container--first'>
                                Additional ID
                            </div>
                        </div>
                    </div>
                }
                {
                    AdditionalId.map((data) => {
                        return (
                            <SecondaryIdentification
                                data={data}
                                guest={guest}
                                key={data.StateId} 
                                onAdditionalIdChange={() => this.setState({ fetchedAddionalId: false })} />
                        );
                    })
                }
                <div
                    className='row'
                    style={{'paddingTop' : '30px'}}>

                    <div className='col-12'>
                        <div className='profile-main__container--header profile-main__container--first'>
                            Add Additional ID
                        </div>
                    </div>
                </div>

                <AddSecondaryIdentification
                    guest={guest} 
                    onAddId={() => this.setState({ fetchedAddionalId: false })} />
            </div>
        );
    }
}

export default ViewIdentification;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ViewIdentification.react.jsx